import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FolderPasswordService } from 'src/app/services/folder-password.service';
import { FolderService } from '../../invoices/services/folder.service';

export interface SetFolderPasswordDialogData {
  folderId: string;
  folderName: string;
  isPasswordProtected: boolean;
}

export type SetFolderPasswordDialogResult =
  | { action: 'set'; passwordHash: string }
  | { action: 'remove' }
  | { action: 'cancel' };

@Component({
  selector: 'app-set-folder-password-dialog',
  templateUrl: './set-folder-password-dialog.component.html',
  styleUrls: ['./set-folder-password-dialog.component.css'],
})
export class SetFolderPasswordDialogComponent {
  newPassword: string = '';
  confirmPassword: string = '';
  showNew: boolean = false;
  showConfirm: boolean = false;
  isSaving: boolean = false;
  mismatch: boolean = false;
  tooShort: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SetFolderPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SetFolderPasswordDialogData,
    private folderPasswordService: FolderPasswordService,
    private folderService: FolderService
  ) {}

  get isEdit(): boolean {
    return this.data.isPasswordProtected;
  }

  async save(): Promise<void> {
    this.mismatch = false;
    this.tooShort = false;

    if (this.newPassword.length < 4) {
      this.tooShort = true;
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      this.mismatch = true;
      return;
    }

    this.isSaving = true;
    const hash = await this.folderPasswordService.hashPassword(this.newPassword);
    await this.folderService.UpdateFolder({
      id: this.data.folderId,
      isPasswordProtected: true,
      passwordHash: hash,
    });
    this.isSaving = false;
    this.dialogRef.close({ action: 'set', passwordHash: hash });
  }

  async removePassword(): Promise<void> {
    this.isSaving = true;
    await this.folderService.UpdateFolder({
      id: this.data.folderId,
      isPasswordProtected: false,
      passwordHash: null,
    });
    this.folderPasswordService.lock(this.data.folderId);
    this.isSaving = false;
    this.dialogRef.close({ action: 'remove' });
  }

  cancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
